import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { FreemiumAPIService } from '../freemium-api.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { GlobalService } from 'src/app/_services/global.service';
import { GaEventsService } from 'src/app/_services/ga-events.service';

type SCREENING_CRITERIA = { criteria_id?: number, criteria_name: string, criteria_type: string, criteria_content: string, job_id: number, isactive?: boolean, created_on?: string, criteriacontent?: string, projectcriteriaid?: string, criteriapriority?: any };
type SCREENING_CRITERIA_SUGGESTION = { suggestion_id?: number, suggestion_name?: string, suggestion_content: string, created_on?: string, selected: boolean };

@Component({
    selector: 'app-ai-resume-form',
    templateUrl: './ai-resume-form.component.html',
    styleUrls: ['./ai-resume-form.component.scss'],
    standalone: false
})
export class AiResumeFormComponent implements OnInit {
  criteriaList = [{
    title: 'Criteria 1',
    desc: 'Solid understanding of user-centered design principles and best practices.'
  },
  {
    title: 'Criteria 2',
    desc: 'Excellent visual design skills with a keen eye for aesthetics and details.'
  },
  {
    title: 'Criteria 3',
    desc: 'Solid understanding of user-centered design principles and best practices.'
  },
  ]

  fileInfoList: any = [];
  fileList: any = [];
  validFileType = ['.pdf'];
  resumeStatus: String = 'upload'; // upload | status | result
  idx = 0;
  totalFilesSucessfullyUploaded: number = 0;
  totalFilesUploadedFailed: number = 0;
  totalFilesUploaded: number = 0;
  showMaxFileError: boolean = false;
  showEvaluationCriteriaLoader: boolean = false;
  jobDescription: UntypedFormControl = new UntypedFormControl(null);
  SUGGESTED_CRITERIA: SCREENING_CRITERIA_SUGGESTION[] = [];
  hideSuggestions: boolean = false;
  removedCriteriaOnEdit = [];
  @Output() fetchCandidateEvent: EventEmitter<any> = new EventEmitter();
  showEvaluation: boolean = true;
  showInfoIcon: boolean = false;
  /**
   * Used for all criteria for AI Screening for job application
   */
  aiScreeningCriteriaForm = this.fb.group({
    criteria_0: this.fb.group({
      question: new UntypedFormControl(),
      id: new UntypedFormControl(null)
    })
  });
  uploadedFileUrls: string[] = [];
  criteriaFetched = false;
  maxFileErrorMessage: string = '';
  criteriaError: boolean = false;

  constructor(private freemiumApiService: FreemiumAPIService,
    private fb: UntypedFormBuilder,
    private gaService: GaEventsService
  ) { }

  ngOnInit() {
    this.freemiumApiService.getScreenResumeErrorHandler.subscribe((res) => {
      if (res?.status === 'error') {
        this.showEvaluation = true;
      }
    })


  }

  onDrop(event: CdkDragDrop<string[]>) {
    const keys = this.formLength();
    moveItemInArray(keys, event.previousIndex, event.currentIndex);
    const reorderedForm: any = {};
    keys.forEach(key => {
      reorderedForm[key] = this.aiScreeningCriteriaForm.get(key);
    });
    this.aiScreeningCriteriaForm = this.fb.group(reorderedForm);
  }

uploadResume(event: any) {
  let newFiles = [];
   newFiles = Array.from(event.target.files);
let filteredNewFiles = [];
  // Filter duplicates
   filteredNewFiles = newFiles.filter(newFile => {
    return !this.fileList.some(existingFile =>
      existingFile.name === newFile.name && existingFile.size === newFile.size
    );
  });

  if (filteredNewFiles.length === 0) {
    return;
  }

  // If total > 10 → show error and stop
  if (this.fileList.length + filteredNewFiles.length > 10) {
    this.showMaxFileError = true;
    this.maxFileErrorMessage = 'You can upload a maximum of 10 resumes';
    return; // ❌ don’t proceed
  }

  this.showMaxFileError = false;
  this.maxFileErrorMessage = '';

  // Merge files
  this.fileList = [...this.fileList, ...filteredNewFiles];

  let keyCount = this.fileInfoList.length, fileType = '';
  filteredNewFiles.forEach(item => {
    if (item && item.name) {
      fileType = item.name.slice(item.name.lastIndexOf('.'));
      if (fileType && this.validFileType.includes(fileType)) {
        if (item.size) {
          let sizeinmb = item.size / Math.pow(10, 6); // MB
          if (sizeinmb > 5) {
            this.fileInfoList.push({
              key: keyCount,
              filename: item.name,
              message: 'File size more than 5MB',
              status: 'fail',
              candidatename: ''
            });
          } else {
            this.fileInfoList.push({
              key: keyCount,
              filename: item.name,
              message: '',
              status: 'load',
              candidatename: ''
            });
          }
        }
      } else {
        this.fileInfoList.push({
          key: keyCount,
          filename: item.name,
          message: 'Unsupported file type',
          status: 'fail',
          candidatename: ''
        });
      }
    }
    item['key'] = keyCount;
    keyCount++;
  });

  this.resumeStatus = 'ongoing';
  this.parseResume(filteredNewFiles);

}



parseResume(data: any[]) {
  data.forEach((file) => {
    if (this.fileInfoList[file.key]?.status === 'load') {
      this.freemiumApiService.aiScreeningUploadResume(file).subscribe((resp: any) => {
        this.totalFilesUploaded++;

        if (resp.status === "success") {
          this.totalFilesSucessfullyUploaded++;
          this.fileInfoList[file.key].status = 'complete';
          this.fileInfoList[file.key].message = '';
          this.uploadedFileUrls.push(resp.data.url);

          // ✅ Run suggestions only once after first success
          if (!this.criteriaFetched) {
            this.criteriaFetched = true;
            this.getSuggestedEvaluationCriteria();

          }
            this.gaService.trackButtonClick("Upload_Resumes");

        } else {
          this.totalFilesUploadedFailed++
          // Parsing failed
          this.fileInfoList[file.key].status = 'fail';
          this.fileInfoList[file.key].message = "An error occurred while parsing the CV. Please try again";
        }
       // if (this.totalFilesUploaded === this.fileList.length) {
          if (this.fileList.length >= 10) {
            this.resumeStatus = 'ongoing';
          } else {
            this.resumeStatus = 'upload';
          }
       // }
      }, (error) => {
        console.error('Error uploading resume:', error);
        // Handle error
        this.fileInfoList[file.key].status = 'fail';
        this.fileInfoList[file.key].message = error?.error?.message || "An error occurred while parsing the CV. Please try again";
     if (this.fileList.length >= 10) {
            this.resumeStatus = 'ongoing';
          } else {
            this.resumeStatus = 'upload';
          }
      });
    } else {
      // For invalid/unsupported files, count them as processed
      this.totalFilesUploaded++;

    if (this.fileList.length >= 10) {
            this.resumeStatus = 'ongoing';
          } else {
            this.resumeStatus = 'upload';
          }
    }
  });
}



  /**
  * Method to fetch project suggested evaluation criteria
  */
  getSuggestedEvaluationCriteria() {
    this.showEvaluationCriteriaLoader = true;
    const payload = { jobdescription: this.jobDescription.value || '' };
    this.freemiumApiService.fetchScreeningCriteriaSuggestions(payload).subscribe((res: any) => {
      this.showEvaluationCriteriaLoader = false;
      if (res && res.status == 'success') {
        this.jobDescription.setErrors(null);
        this.jobDescription.updateValueAndValidity();

        const validCriteriaSuggestions = (res?.data || []).map((item: any) => item).filter(Boolean);
        if (validCriteriaSuggestions.length) {
          this.SUGGESTED_CRITERIA = res.data?.map((item: any) => ({ suggestion_content: item, selected: false }));
        }
      } else {
        this.jobDescription.setErrors({'Invalid': true});
        this.jobDescription.updateValueAndValidity()
      }
    },(error) => {
      this.jobDescription.setErrors({'Invalid': true});
      this.jobDescription.updateValueAndValidity();
    })
  };

  /**
 * Length of Form Group used to know the count of sub-forms present
 */
  formLength() {
    const innerFormGroup = this.aiScreeningCriteriaForm.controls;
    return Object.keys(innerFormGroup);
  }

  /**
 * Use given static criteria
 * @param c criteia (question)
 */
  useGivenCriteria(c: SCREENING_CRITERIA_SUGGESTION) {
  this.hideSuggestions = true;
    const formKeys = Object.keys(this.aiScreeningCriteriaForm.controls);
    if (formKeys.length) {
      const emptyKey = Object.keys(this.aiScreeningCriteriaForm.controls).pop();
      const firstFG = this.aiScreeningCriteriaForm.controls[emptyKey] as UntypedFormGroup;

      if (!firstFG.getRawValue()?.question?.trim()) {
        firstFG.patchValue({ question: c.suggestion_content });
      } else {
        this.addNewCriteria({
          criteria_content: c.suggestion_content,
          criteria_id: null
        });
      }
    } else {
      this.addNewCriteria({
        criteria_content: c.suggestion_content,
        criteria_id: null
      });
    }
    c.selected = true;
    this.SUGGESTED_CRITERIA.sort(criteria => criteria.selected ? 1 : -1);
  };



  /**
 * Add new criteria form
 */
  addNewCriteria(data = null) {
    const formGroup = this.aiScreeningCriteriaForm;
    const uniqueId: string = GlobalService.generateUniqueId();
    if (data) {
      formGroup.addControl(`criteria_${uniqueId}`, new UntypedFormGroup({
        question: new UntypedFormControl(data?.criteria_content),
        id: new UntypedFormControl(data?.criteria_id)
      }));
    } else {
      formGroup.addControl(`criteria_${uniqueId}`, new UntypedFormGroup({
        question: new UntypedFormControl(),
        id: new UntypedFormControl(null)
      }));
    }
  }

  /**
 * Delete any criteria from ai screening
 * @param formGroup
 */
  deleteCriteria(formGroup) {
    const fg = this.aiScreeningCriteriaForm.controls[`${formGroup}`] as UntypedFormGroup;
    const deletedCriteriaId = fg.controls['id'].value;
    if (deletedCriteriaId) {
      this.removedCriteriaOnEdit.push({
        action: 'DELETE',
        criteria_id: deletedCriteriaId
      });
    }
    this.aiScreeningCriteriaForm.removeControl(formGroup);
    this.refreshCriteriaSuggestionsBasedOnFormState();
  }

  /**
 * Update criteria suggestions on the UI based on criteria form current state
 */
  refreshCriteriaSuggestionsBasedOnFormState() {
    const formGroup = this.aiScreeningCriteriaForm;
    const formGroupKeys = Object.keys(formGroup.controls);
    this.SUGGESTED_CRITERIA.forEach(suggestion => {
      const selectedSuggestionIdx = formGroupKeys.findIndex(key => {
        const FG = formGroup.controls[`${key}`] as UntypedFormGroup;
        return FG.getRawValue()?.question?.trim()?.toLowerCase() === suggestion.suggestion_content.trim().toLowerCase();
      });
      if (selectedSuggestionIdx !== -1) {
        suggestion.selected = true;
      } else {
        suggestion.selected = false;
      }
    });
    this.SUGGESTED_CRITERIA.sort(criteria => criteria.selected ? 1 : -1);
  }

  get evaluationButtonDisabled() {
    if ((this.jobDescription.value?.trim()) && (this.aiScreeningCriteriaForm.value.criteria_0?.question != null && this.aiScreeningCriteriaForm.value.criteria_0?.question?.trim() != '') &&
  this.totalFilesSucessfullyUploaded > 0) {
      return false;
    } else {
      return true;
    }
  }

  getCandidates() {
  const raw = this.aiScreeningCriteriaForm.getRawValue();
  const keys = Object.keys(this.aiScreeningCriteriaForm.controls);

  const payloadData: any[] = [];
  let hasError = false;

  keys.forEach((key, idx) => {
    const questionCtrl = this.aiScreeningCriteriaForm.get(key)?.get('question');
    const value = (questionCtrl?.value ?? '').toString();

    const cleaned = value
      .trim()
      .replace(/[\n\r\t]/gm, '')
      .replace(/[^a-zA-Z0-9]/g, '');

    if (cleaned.length < 10) {
      hasError = true;
      questionCtrl?.setErrors({ ...(questionCtrl.errors || {}), incorrect: true });
      questionCtrl?.markAsTouched();
    } else {
      // clear only the 'incorrect' error, keep others if any
      const errs = { ...(questionCtrl?.errors || {}) };
      delete (errs as any).incorrect;
      questionCtrl?.setErrors(Object.keys(errs).length ? errs : null);
    }

    payloadData.push({
      criteriacontent: value,
      criteriapriority: idx + 1
    });
  });

  if (hasError || !this.jobDescription.value) {
    this.showEvaluation = true;
    return;
  } else {
      this.showEvaluation = false;

  }

  const payload = {
    jobdescription: this.jobDescription.value,
    resumeurls: this.uploadedFileUrls,
    screeningcriteria: payloadData,
  };
  this.gaService.trackButtonClick("Evaluate_Resume");

  this.freemiumApiService.emitEvaluateErrorEvent({ status: 'fetch', data: payload });
  this.fetchCandidateEvent.emit({ status: 'fetch', data: payload });

}




  JdClick() {
    this.showInfoIcon = true;
  }

  deleteResume(file: any) {
    // Remove from fileList
    this.fileList = this.fileList.filter((f: any) => f.key !== file.key);

    // Remove from fileInfoList
    this.fileInfoList = this.fileInfoList.filter((f: any) => f.key !== file.key);

    // Remove uploaded URL if present
    if (file.status === 'complete') {
      this.uploadedFileUrls = this.uploadedFileUrls.filter(url => url !== file.url);
      this.totalFilesSucessfullyUploaded--;
    }

    this.totalFilesUploaded = this.fileInfoList.filter((f: any) => f.status === 'complete' || f.status === 'fail').length;

    // ✅ Reset resumeStatus after delete
    if (this.fileList.length < 10) {
      this.resumeStatus = 'upload';
    }
  }


}
